// Binlik ayraç (virgül) + iki ondalık basamak (nokta) — örn: 12,250.00
export const paraFormatla = (deger) =>
  Number(deger || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
